import { createRefMemo } from './create-ref-memo';

export const getBonusGamesSet = createRefMemo(
  (bonusGames: number[] | undefined) => new Set(bonusGames ?? [])
);
